<div *ngIf="isLoading" class="d-flex justify-content-center my-5">
  <div class="spinner-border text-warning" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
</div>
<div *ngIf="!isLoading">
  <div class="backContainer">
    <a href="#" class="back-link" routerLink="/main/home">
      <img src="../../../../assets/images/IconleftTurn.svg" /> Back
    </a>
  </div>


<div class="page-wrapper">
<div class="container" [formGroup]="profileForm">
  <div class="profile-section">
    <div class="avatar">
      <img
        src="{{
          profilePic
            ? profilePic
            : '../../../../../../assets/images/dummy_Pic.svg'
        }}"
        class="avatar"
      />
    </div>

    <div class="profile-info">
      <div class="input-group">
        <label for="firstName">First Name</label>
        <input id="firstName" formControlName="firstName" class="form_Input" />
      </div>

      <div class="input-group">
        <label for="lastName">Last Name</label>
        <input id="lastName" formControlName="lastName" class="form_Input" />
      </div>

      <div class="input-group">
        <label for="email">Email</label>
        <input id="email" formControlName="email" class="form_Input" disabled />
      </div>
    </div>
  </div>

  <div
    class="addBtn d-flex align-items-center justify-content-end"
    *ngIf="addKid == false"
  >
    <!-- <div
      class="form-check form-switch autopay-switch d-flex justify-content-center align-items-center mb-3"
    >
      <input
        class="form-check-input"
        type="checkbox"
        [checked]="profileForm.get('isAutoPaymentEnabled')?.value"
        (change)="toggleAutoPay()"
      />
      <label class="form-check-label ms-2"> Autopay </label>
    </div> -->

    <button class="btn btn-Login2" (click)="kidAdd()">+ Add Kid</button>
  </div>
  <div class="notAddDiv" *ngIf="addKid == false">
    <div class="input-group">
      <label for="numberOfKids">No. Of Kids</label>
      <input
        type="number"
        class="form-control form_Input mt-2"
        id="numberOfKids"
        placeholder="Enter No. Of Children"
        formControlName="numberOfKids"
        (input)="generateChildControls()"
        min="0"
        disabled
      />
    </div>
    <div class="count_Div mt-4 mb-4 d-flex" *ngIf="childArray?.length != 0">
      <div
        class="main_Child_count_Div ml-2 mr-2 cursor"
        *ngFor="let child of childArray; let i = index"
        [ngClass]="{
          main_Child_count_Div_hover:
            i === hoveredIndex || i === currentChildIndex
        }"
        (click)="selectChild(i)"
        (mouseenter)="onMouseEnter(i)"
        (mouseleave)="onMouseLeave()"
      >
        Child {{ i + 1 }}
      </div>
    </div>

    <div class="form-group mt-2" *ngIf="childArray?.length">
      <label class="profile_Pic_Label cursor">
        <img
          [src]="
            selectedChild?.profilePic
              ? selectedChild?.profilePic
              : '../../../assets/images/dummy_Pic.svg'
          "
          style="height: 150px; width: 150px; border-radius: 10px"
        />
        <p class="profile_Pic_Text">+ Add Profile Photo</p>
        <input
          #Btn
          type="file"
          accept="image/*"
          class="profile_Pic_Input"
          (change)="fileChangeEvent2($event, addKidmodal, Btn, i)"
          hidden
        />
      </label>
    </div>

    <div class="input-group mt-2" *ngIf="childArray?.length != 0">
      <label for="firstName">First Name</label>
      <input
        type="text"
        class="form-control form_Input mt-2"
        id="firstName"
        placeholder="Enter First Name"
        [(ngModel)]="selectedChild.firstName"
        [ngModelOptions]="{ standalone: true }"
        required
      />
      <div
        *ngIf="
          !selectedChild.firstName && (firstName?.dirty || firstName?.touched)
        "
        class="errorinput text-left"
      >
        *First Name is required.
      </div>
    </div>

    <div class="input-group mt-2" *ngIf="childArray?.length != 0">
      <label for="lastName">Last Name</label>
      <input
        type="text"
        class="form-control form_Input mt-2"
        id="lastName"
        placeholder="Enter Last Name"
        [(ngModel)]="selectedChild.lastName"
        [ngModelOptions]="{ standalone: true }"
        required
      />
      <div
        *ngIf="
          !selectedChild.lastName && (lastName?.dirty || lastName?.touched)
        "
        class="errorinput text-left"
      >
        *Last Name is required.
      </div>
    </div>

    <div class="" *ngIf="childArray?.length != 0">
      <div class="input-group mt-2 col-md-6">
        <label for="age">Age</label>
        <input
          type="number"
          class="form-control form_Input mt-2"
          id="age"
          placeholder="Enter Age"
          [(ngModel)]="selectedChild.age"
          [ngModelOptions]="{ standalone: true }"
          required
        />
        <div
          *ngIf="!selectedChild.age && (age?.dirty || age?.touched)"
          class="errorinput text-left"
        >
          *Age is required.
        </div>
      </div>

      <div class="input-group mt-2 col-md-6">
        <label for="gender">Gender</label>
        <input
          type="text"
          class="form-control form_Input mt-2"
          id="gender"
          placeholder="Enter Gender"
          [(ngModel)]="selectedChild.gender"
          [ngModelOptions]="{ standalone: true }"
          (ngModelChange)="onGenderChange($event)"
          required
        />
        <div
          *ngIf="!selectedChild.gender && (gender?.dirty || gender?.touched)"
          class="errorinput text-left"
        >
          *Gender is required.
        </div>
      </div>
    </div>
  </div>

  <div class="modal-body" *ngIf="addKid == true">
    <hr />
    <div class="addChildForm p-0">
      <div class="form-group">
        <label class="profile_Pic_Label cursor">
          <img
            [src]="
              profileImag ? profileImag : '../../../assets/images/dummy_Pic.svg'
            "
            style="height: 150px; width: 150px; border-radius: 10px"
          />
          <p class="profile_Pic_Text">+ Add Profile Photo</p>
          <input
            #Btn
            type="file"
            accept="image/*"
            class="profile_Pic_Input"
            (change)="fileChangeEvent2($event, addKidmodal, Btn, i)"
            hidden
          />
        </label>
      </div>
      <div class="form-group">
        <label for="firstName">First Name</label>
        <input
          type="text"
          class="form-control form_Input mt-2"
          id="firstName"
          placeholder="Enter First Name"
          [(ngModel)]="firstName"
          [ngModelOptions]="{ standalone: true }"
          required
        />
        <!-- <div
            *ngIf="
              !selectedChild.firstName &&
              (firstName?.dirty || firstName?.touched)
            "
            class="errorinput text-left"
          >
            *First Name is required.
          </div> -->
      </div>

      <div class="form-group mt-2">
        <label for="lastName">Last Name</label>
        <input
          type="text"
          class="form-control form_Input mt-2"
          id="lastName"
          placeholder="Enter Last Name"
          [(ngModel)]="lastName"
          [ngModelOptions]="{ standalone: true }"
          required
        />
        <!-- <div
            *ngIf="
              !selectedChild.lastName &&
              (lastName?.dirty || lastName?.touched)
            "
            class="errorinput text-left"
          >
            *Last Name is required.
          </div> -->
      </div>

      <div class="d-flex">
        <div class="form-group mt-2 px-1 col-md-6" style="padding-left: 0px">
          <label for="age">Age</label>
          <input
            type="number"
            class="form-control form_Input mt-2"
            id="age"
            placeholder="Enter Age"
            [(ngModel)]="age"
            [ngModelOptions]="{ standalone: true }"
            required
          />
          <!-- <div
            *ngIf="!selectedChild.age && (age?.dirty || age?.touched)"
            class="errorinput text-left"
          >
            *Age is required.
          </div> -->
        </div>

        <div class="form-group mt-2 col-md-6">
          <label for="gender">Gender</label>
          <select
            class="form-control form_Input mt-2"
            id="gender"
            [(ngModel)]="gender"
            [ngModelOptions]="{ standalone: true }"
            required
          >
            <option value="" disabled>Select Gender</option>
            <option value="male">Male</option>
            <option value="female">Female</option>
            <option value="other">Other</option>
          </select>
          <!-- <div
            *ngIf="!selectedChild.gender && (gender?.dirty || gender?.touched)"
            class="errorinput text-left"
          >
            *Gender is required.
          </div> -->
        </div>
      </div>
    </div>
    <div
      class="btnDiv mt-4"
      *ngIf="addKid == true"
      style="display: flex; justify-content: center"
    >
      <button class="btn btn-Login2 mx-2" (click)="saveChild()">Add Kid</button>
      <button class="btn btn-Login3" (click)="cancelChild()">Cancel</button>
    </div>
  </div>
  <!-- <div
    class="childCount"
   
  > -->

  <!-- <div class="children-section">
    <div class="tabs">
      <button
        class="tab"
        *ngFor="let child of children; let i = index"
        [class.active]="selectedChildIndex === i"
        (click)="selectChild(i)"
      >
        Child {{ i + 1 }}
      </button>
    </div>

    <div
      class="child-info"
      *ngFor="let child of children; let i = index"
      [style.display]="selectedChildIndex === i ? 'block' : 'none'"
    >
      <div class="input-group">
        <label for="childFirstName">First Name</label>
        <input id="childFirstName" formControlName="firstName" />
      </div>

      <div class="input-group">
        <label for="childLastName">Last Name</label>
        <input id="childLastName" formControlName="lastName" />
      </div>

      <div class="input-group">
        <label for="childAge">Age</label>
        <input id="childAge" formControlName="age" />
      </div>

      <div class="input-group">
        <label for="childGender">Gender</label>
        <input id="childGender" formControlName="gender" />
      </div>
    </div>
  </div> -->
  <button class="btn btn-Login" (click)="editForm()" *ngIf="addKid == false">
    Save Profile
  </button>
</div>
</div>
<ng-template #addKidmodal let-modal>
  <app-spinner *ngIf="isLoading1" [type]="'normal'"></app-spinner>
  <div class="modal-header">
    <h5 class="modal-title">Kid Image</h5>
    <button
      type="button"
      class="close btn cross_btn"
      data-dismiss="modal"
      (click)="closeModal('dismiss')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="col-md-12 mt-2 pe-5 ps-5">
      <div class="cropper" *ngIf="imageChangedEvent2">
        <h5 class="cropper-title">Crop Image</h5>
        <image-cropper
          [imageChangedEvent]="imageChangedEvent2"
          [maintainAspectRatio]="true"
          [aspectRatio]="1 / 1"
          cropperMinWidth="200"
          cropperMinHeight="200"
          resizeToWidth="600"
          resizeToHeight="600"
          format="png"
          (imageCropped)="imageCropped($event)"
          (imageLoaded)="imageLoaded()"
          (cropperReady)="cropperReady()"
          (loadImageFailed)="loadImageFailed()"
        >
        </image-cropper>
        <!-- <button class="btn btn-danger mr-rt-1x" (click)="cancel()">
          Cancel
        </button> -->
        <div class="savebtn mt-4 d-flex justify-content-center">
          <button (click)="save2()" class="btn btn-Login ml-2">Save</button>
        </div>
      </div>
    </div>
  </div>
</ng-template>
